export default __webpack_public_path__ + "static/media/photo--sm--5.8f61af48.jpg";